var map = {
	"./1.webp": 393,
	"./2.webp": 9724,
	"./3.webp": 591,
	"./4.webp": 562,
	"./581be386-ea91-43e7-b193-6b369b9d29e3-min.webp": 5991,
	"./xx.webp": 450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5084;